module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/barra-de-ouro-3a3f1dc0be93820532edb5bed767fda7.png";